import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { setLogout } from '../../redux/authSlice';
import { useNavigate } from 'react-router-dom';

function LogoutPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  useEffect(() => {
    dispatch(setLogout());
    navigate('/login');
  }, [dispatch, navigate])

}

export default LogoutPage